import React from 'react'

import FormManager from "../../../../../core/gd-form/common/form-manager"
import FormModel from "../../../../../core/gd-form/common/form-model-manager"

type Props =  {
    className?      : string

    form?           : FormModel | FormManager
    disabled?       : boolean

    onClick?        : callback
    onCancel?       : callback
}

// const debug = "ButtonSubmitAI"
const debug = false

export default class ButtonSubmitAI extends React.Component<Props> {

    public form? : FormManager | FormModel

    constructor(props: Props) {
        super(props)

        this.form = this.props.form
    }

    componentDidMount() {
        this.form?.registerSubmitButton(this)
    }

    setForm = (form : FormManager | FormModel) => {
        if (!this.form) {
            this.form = form;
            this.form.registerSubmitButton(this);
            this.forceUpdate()
        } else {
            console.warn("ButtonSubmitNew setForm error: form already set")
        }
    }

    onClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()

        debug && console.log(debug, 'onClick', this.props.onClick, this.form?.onSubmitClick, this.form)

        if (this.props.disabled) {
            return
        }

        if(this.props.onClick) {
            this.props.onClick()
        } else {
            this.form?.onSubmitClick()
        }
    };

    onCancel = ()=> {
        // this.props.onCancel()
    }

    render() {
        let classes = Classes('ai-submit-btn flex-row-center-center s20', this.props.className, {
            'stop'      : this.form?.isSubmitting,
            'send'      : !this.form?.isSubmitting,
            'disabled'  : this.props.disabled
        })

        if (this.form?.isSubmitting) {
            return (
                <div
                    className   = {classes}
                    onClick     = {this.onCancel}
                >
                    <div className = 'flex-row-center-center'>
                        <div className="i5-stop-solid ui5-ico-14"/>
                    </div>
                </div>
            )
        }

        return (
            <div
                className       = {classes}
                onClick         = {this.onClick}
                aria-disabled   = {this.props.disabled}
                role            = "button"
            >
                <div className="i5-chat-send ui5-color-white fs-15"/>
            </div>
        )
    }
}
